import {
  Campaign,
  Campaigns,
  ProductRenderCampaign,
  SliderCampaign,
} from '~/services/types/abtasty'

export default class ABTestCampaigns {
  // struct passée par AB Tasty listant les campagnes
  public campaigns: Campaign[] = []

  // short list
  public sliderCampaigns: Map<string, SliderCampaign[]> = new Map()
  public productRenderCampaigns: Map<string, ProductRenderCampaign> = new Map()

  public static fromCampaigns(data: Campaigns): ABTestCampaigns {
    const res = new ABTestCampaigns()

    res.campaigns = data.campaigns

    const sliderCampaigns: Campaign[] = data.campaigns.filter(
      (c: Campaign) =>
        c.variation.modifications.type === 'FLAG' &&
        c.variation.modifications.value.product_slider
    )

    for (const sliderCampaign of sliderCampaigns) {
      const productSlider =
        sliderCampaign.variation.modifications.value.product_slider
      const product = productSlider?.product
      if (!res.sliderCampaigns.has(product)) {
        res.sliderCampaigns.set(product, [])
      }

      const campaigns: SliderCampaign[] = res.sliderCampaigns.get(product) || []

      campaigns.push({
        id: sliderCampaign.id,
        campaignName: sliderCampaign.name,
        variationGroupId: sliderCampaign.variationGroupId,
        variation: sliderCampaign.variation,
        product: productSlider?.product,
        color: productSlider?.color,
        isOriginal: sliderCampaign.variation.name === 'Original',
        alternateSliderId: productSlider?.alternate_slider_id,
      })

      res.sliderCampaigns.set(product, campaigns)
    }

    const productRenderCampaigns: Campaign[] = data.campaigns.filter(
      (c: Campaign) =>
        c.variation.modifications.type === 'FLAG' &&
        c.variation.modifications.value.product_render
    )

    for (const productRenderCampaign of productRenderCampaigns) {
      const productRender =
        productRenderCampaign.variation.modifications.value.product_render
      const product = productRender?.product

      if (product) {
        res.productRenderCampaigns.set(product, {
          id: productRenderCampaign.id,
          campaignName: productRenderCampaign.name,
          variationGroupId: productRenderCampaign.variationGroupId,
          variation: productRenderCampaign.variation,
          product: productRender?.product,
          isOriginal: productRenderCampaign.variation.name === 'Original',
          version: productRender.version,
        })
      }
    }

    return res
  }

  public hasProductSliderTest(productUid: string): boolean {
    return this.sliderCampaigns.has(productUid)
  }

  public getProductSliderTest(productUid: string): SliderCampaign[] | null {
    const res = this.sliderCampaigns.get(productUid)
    return res === undefined ? null : res
  }

  public hasProductRenderTest(productUid: string): boolean {
    return this.productRenderCampaigns.has(productUid)
  }

  public getProductRenderTest(
    productUid: string
  ): ProductRenderCampaign | null {
    const res = this.productRenderCampaigns.get(productUid)
    return res === undefined ? null : res
  }

  public hasCampaignByName(campaignName: string): boolean {
    return this.campaigns.some((c) => c.name === campaignName)
  }

  public getCampaignByName(campaignName: string): Campaign | null {
    const res = this.campaigns.find((c) => c.name === campaignName)
    return res === undefined ? null : res
  }

  public toJSON() {
    return Object.assign({}, this)
  }
}
